module.exports = __webpack_public_path__ + "img/search.a86e8ca9.svg";